import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { companyId: Number }

  connect() {
    // We'll find the modal when needed instead of on connect
    this.confirmationModal = null
  }

  getConfirmationModal() {
    // Try to find the modal each time to ensure it's available
    const modalElement = document.querySelector('[data-controller~="confirmation-modal"]')
    console.log('Modal element found:', modalElement)
    
    if (modalElement) {
      const controller = this.application.getControllerForElementAndIdentifier(
        modalElement,
        "confirmation-modal"
      )
      console.log('Modal controller found:', controller)
      return controller
    }
    return null
  }

  showVerifyConfirmation(event) {
    const button = event.currentTarget
    const companyId = button.dataset.companyId
    const verifyUrl = button.dataset.verifyUrl
    
    const modal = this.getConfirmationModal()
    console.log('Verification button clicked', { companyId, verifyUrl, modal })
    
    if (modal) {
      modal.show(
        "Patvirtinti įmonę",
        "Ar tikrai norite patvirtinti šią įmonę? Šio veiksmo negalima atšaukti.",
        () => this.verifyCompany(verifyUrl)
      )
    } else {
      console.error('Confirmation modal not found')
      // Fallback to native confirm
      if (confirm("Ar tikrai norite patvirtinti šią įmonę?")) {
        this.verifyCompany(verifyUrl)
      }
    }
  }

  verifyCompany(url) {
    fetch(url, {
      method: 'PATCH',
      headers: {
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Let Turbo handle the response
      Turbo.renderStreamMessage(html)
    })
    .catch(error => {
      console.error('Failed to verify company:', error)
    })
  }
}
